<div class="home-page">
  <div class="home-stack">
    <app-home-briefing />

    <app-home-spotlight />

    <div class="home-grid">
      <app-home-attention-queue />

      <div class="grid-side d-flex flex-column">
        <app-home-pulse />
        <app-home-launcher />
      </div>
    </div>
  </div>
</div>
